
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersNight as ObiLightningLightSnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-night.js';
 
 
 

 
 export const ObiLightningLightSnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-night',
   elementClass: ObiLightningLightSnowShowersNightElement,
   events: {
     
   }
  });
 
 